import { z } from 'zod'

/**
 * Gear categories for technical riders
 */
export const gearCategoryValues = [
  'microphone',
  'monitor',
  'stand',
  'instrument',
  'backline',
  'accessory',
  'other',
] as const

export type GearCategory = (typeof gearCategoryValues)[number]

/**
 * A single gear requirement item
 */
export const gearRequirementSchema = z.object({
  category: z.enum(gearCategoryValues),
  name: z.string(),
  quantity: z.number().default(1),
  notes: z.string().optional(),
  /** Whether the artist provides this item (vs venue/production) */
  providedByArtist: z.boolean().default(false),
})

export type GearRequirement = z.infer<typeof gearRequirementSchema>

/**
 * Monitor preference types
 */
export const monitorPreferenceValues = ['wedge', 'iem', 'both', 'none'] as const
export type MonitorPreference = (typeof monitorPreferenceValues)[number]

/**
 * Profile gear configuration - personal defaults for a user
 */
export const profileGearSchema = z.object({
  /** Role in the band (e.g., "Vocals", "Lead Guitar", "Drums") */
  role: z.string().optional(),
  /** Default gear requirements */
  requirements: z.array(gearRequirementSchema).default([]),
  /** Monitor preference */
  monitorPreference: z.enum(monitorPreferenceValues).optional(),
  /** General notes for sound engineers */
  notes: z.string().optional(),
})

export type ProfileGear = z.infer<typeof profileGearSchema>
